module.exports = __webpack_public_path__ + "img/close-menu.37b14805.svg";